import React from "react";
import "../styles/colorLabels.css"

function ColorLabels () {

    return (
        <div className="centerColors">
            <div className="colorLabels">
                <li id="color-key">color key: </li>
                <li id="elite">elite</li>
                <li id="great">strong</li>
                <li id="above-average">favorable</li>
                <li id="poor">poor</li>
            </div>
        </div>
    )
}

export default ColorLabels